import { getColor } from 'basic-components';
import { CommonEnums } from 'dashboard-services/api/common';
import { DataStorageEnums } from 'dashboard-services/api/dataStorage';
import { DataTransformEnums } from 'dashboard-services/api/dataTransform';
import { ActionService } from 'dashboard-services/services';
import { globalActions } from 'primary-components';

import { CurvesUtils, LocalStorageUtils, TimeSeriesUtils } from 'utils';

import { MetadataLabel } from 'primary/TsSettings';

// series actions are not dependent on old TimeSeries actions or components
export default (() => {

  const defaultState = {
    range: DataStorageEnums.DATA_RANGE.LAST,
    lastTypeAmount: "1",
    lastType: DataStorageEnums.LAST_TYPE.VALUE,
    
    fromSelected: undefined,
    from: undefined,
    
    toSelected: undefined,
    to: undefined,

    symbolSize: undefined,
    csvHeaders: CurvesUtils.DEFAULT_CSV_HEADERS,
    dateFormat: TimeSeriesUtils.DAILY_DATE_FORMAT,
    timeZone: undefined,
    periodType: DataTransformEnums.PERIOD_TYPE.MONTH,
    contractSort: CommonEnums.SORT_ORDER.ASCENDING,
    isRelative: "false",
    fillBlanks: "",
    formulaExpressions: {},
  }
  
  const ON_CHANGE = 'ON_CHANGE_SETTINGS_CURVES'
  const onChange = ActionService.makeActionCreator(ON_CHANGE, 'value', 'name')

  const CLEAR = 'CLEAR_LIST_SETTINGS_CURVES'
  const clear = ActionService.makeActionCreator(CLEAR)

  const saveDefaultSettings = () => (_, getState) => {
    const itemsToSave = getState().curvesState.settingsState
    LocalStorageUtils.setCurveDefaultSettings(itemsToSave)
  }

  const clearDefaultSettings = () => dispatch => {
    const itemsToSave = defaultState
    LocalStorageUtils.setCurveDefaultSettings(itemsToSave)
    dispatch(clear())
    dispatch(globalActions.getMessageStore()).success("Default settings has been restored.")
  }

  const getMetadataFilter = curve => ({
    [CurvesUtils.ROOT]: [curve.root],
    [CurvesUtils.PRODUCT]: [curve.product]
  })

  const getSelect = response => (response?.items || []).filter(item => item.type !== DataStorageEnums.KEY_TYPE.SYMBOL).map(item => ({ 
    value: item.name, 
    label: <MetadataLabel name={item.name}/>,
    color: getColor("grey-dark"),
    type: `${item.type}_KEY`
  }))

  return {
    onChange,
    ON_CHANGE,
    CLEAR,
    clear,
    saveDefaultSettings,
    clearDefaultSettings,
    defaultState,
    getMetadataFilter,
    getSelect
  }
})()
